import {
	type AdminGoldenAsset,
	type GenerationJob,
	GenerationJobStatus,
	type GoldenAssetKind,
	type GoldenAssetOwnerType,
	GoldenAssetStatus,
} from "@storyline/shared";

const isActiveJob = (job: GenerationJob): boolean =>
	job.status === GenerationJobStatus.PENDING || job.status === GenerationJobStatus.PROCESSING;

export const generatingAssetKeys = (jobs: GenerationJob[]): Set<string> => {
	const keys = new Set<string>();
	for (const job of jobs) {
		if (!isActiveJob(job)) {
			continue;
		}
		const assetKind = job.params && typeof job.params.assetKind === "string" ? job.params.assetKind : null;
		if (assetKind) {
			keys.add(`${job.targetId}:${assetKind}`);
		}
	}
	return keys;
};

export const slotKey = (ownerId: string | null, kind: GoldenAssetKind): string => `${ownerId}:${kind}`;

export type AssetSlot = {
	ownerType: GoldenAssetOwnerType;
	ownerId: string | null;
	kind: GoldenAssetKind;
	versions: AdminGoldenAsset[];
	current: AdminGoldenAsset | null;
	candidates: AdminGoldenAsset[];
};

export const selectAssetSlot = (
	assets: AdminGoldenAsset[],
	ownerType: GoldenAssetOwnerType,
	ownerId: string | null,
	kind: GoldenAssetKind,
): AssetSlot => {
	const versions = assets
		.filter((asset) => asset.kind === kind && asset.ownerType === ownerType && asset.ownerId === ownerId)
		.sort((a, b) => b.version - a.version);
	const current =
		versions.find((asset) => asset.status === GoldenAssetStatus.LOCKED) ??
		versions.find((asset) => asset.status === GoldenAssetStatus.APPROVED) ??
		null;
	const candidates = versions.filter((asset) => asset.status === GoldenAssetStatus.CANDIDATE);
	return { ownerType, ownerId, kind, versions, current, candidates };
};
